import * as Sentry from "@sentry/vue";
import Buefy from "buefy";
import Vue from "vue";
import App from "./App.vue";
import i18n from "./i18n";
import router from "./router";
import store from "./store";
import { startSessionHeartbeat } from "./sessionHeartbeat";

Vue.use(Buefy);
startSessionHeartbeat();
Vue.config.productionTip = false;
Sentry.init({
  Vue,
  dsn: "https://fa0b79f6f2308f548e7292e8292d53f2@sentry.uco.co.il/11",
  environment: process.env.NODE_ENV,
  release: `fixdigital-vue@0.1.0`,
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 0,
  tracesSampleRate: 1.0,
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracePropagationTargets: ["localhost", /^https:\/\/fixdigital\.co\.il/, /^https:\/\/staging\.fixdigital\.co\.il/, /^\//],
    }),
    new Sentry.Replay(),
  ],
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
